import React from 'react';
import GridConditionOrdinary from './GridConditionOrdinary';
import GridConditionOrdinaryEdit from './GridConditionOrdinaryEdit';
import GridDeletedOrdinary from './GridDeletedOrdinary';
import { RootState, useSelector } from '../../../redux/store';
import { CONDITION_VIEW_MODES, MANAGE_CONDITION_TYPES } from '../../../constants';

const ConditionOrdinary = (): React.ReactElement => {
  const { isLoading, selectedTab, selectedViewMode, selectedSteelMaker, selectedBusinessType, condition } = useSelector((state: RootState) => state.condition);
  const isOrdinarySelected: boolean = selectedTab === MANAGE_CONDITION_TYPES.ORDINARY;
  const isEditing: boolean = selectedViewMode === CONDITION_VIEW_MODES.EDITING;

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      {isOrdinarySelected ? (
        <>
          {isEditing && condition ? (
            <>
              <GridConditionOrdinaryEdit
                isLoading={isLoading}
                selectedViewMode={selectedViewMode}
                selectedSteelMaker={selectedSteelMaker}
                selectedBusinessType={selectedBusinessType}
                condition={condition}
              />
              <GridDeletedOrdinary isLoading={isLoading} selectedViewMode={selectedViewMode} condition={condition} />
            </>
          ) : (
            <GridConditionOrdinary
              isLoading={isLoading}
              selectedViewMode={selectedViewMode}
              selectedSteelMaker={selectedSteelMaker}
              selectedBusinessType={selectedBusinessType}
              condition={condition}
            />
          )}
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default ConditionOrdinary;
